import { render, staticRenderFns } from "./WebPartHRSetting.vue?vue&type=template&id=3aec5bf6&"
import script from "./WebPartHRSetting.vue?vue&type=script&lang=js&"
export * from "./WebPartHRSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aec5bf6')) {
      api.createRecord('3aec5bf6', component.options)
    } else {
      api.reload('3aec5bf6', component.options)
    }
    module.hot.accept("./WebPartHRSetting.vue?vue&type=template&id=3aec5bf6&", function () {
      api.rerender('3aec5bf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartHRSetting.vue"
export default component.exports